// @flow
import {action, observable} from 'mobx'

type key = 'size' | 'page' | 'count'

export class Pagination {
  $key: key;
  $value: number;

  @observable size: number = 0
  @observable page: number = 0
  @observable count: number = 0

  @action set(key: key, value: number) {
    this[key] = value
  }
}
